import { render } from "./Modern.svg?vue&type=template&id=d57c72ba"
const script = {}
script.render = render

export default script